import React from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import Footer from "../components/common/footer";
import articles from "../data/articles.js";
import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/articles.css";

// Sort articles by date (newest first)
const sortedArticles = [...articles].sort((a, b) => new Date(b.date) - new Date(a.date));

const Articles = () => {
    const currentSEO = SEO.find(item => item.page === "articles");

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Articles | ${INFO.main.title}`}</title>
                <meta name="description" content={currentSEO?.description} />
                <meta name="keywords" content={currentSEO?.keywords.join(", ")} />
                <link rel="canonical" href={`${INFO.socials.website}/articles`} />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={`Articles | ${INFO.main.title}`} />
                <meta property="og:description" content={currentSEO?.description} />
                <meta property="og:url" content={`${INFO.socials.website}/articles`} />
                <meta property="og:image" content={`${INFO.socials.website}/homepage.jpg`} />
            </Helmet>
            
            <div className="page-content">
                <div className="content-wrapper">
                    <div className="articles-container">
                        <div className="title articles-title">
                            Hair Care Tips & News
                        </div>
                        <div className="subtitle articles-subtitle">
                            Stay updated with the latest hair care tips and trends
                        </div>

                        <div className="articles-list">
                            {sortedArticles.map(article => (
                                <div key={article.id} className="article-card">
                                    <h2 className="article-card-title">{article.title}</h2>
                                    <p className="article-card-summary">{article.summary}</p>
                                    <Link to={`/articles/${article.shortName}`} className="article-card-link">
                                        Read More
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    <div className="page-footer">
                        <Footer />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Articles; 